module.exports = __webpack_public_path__ + "img/repair_bg_diagnosis@2x.png";